import { useMemo } from 'react';
import { Order } from 'shared/types/cart/Order';
import { ShippingMethod } from 'shared/types/cart/ShippingMethod';
import useOrderFetch from './useOrderFetch';

const useOrderData = (order?: Order) => {
  const { shippingMethods } = useOrderFetch(false);

  const orderDateCreated = useMemo(() => {
    return order?.createdAt && new Date(order?.createdAt);
  }, [order]);

  const orderDateShipping = useMemo(() => {
    return order?.createdAt && new Date(new Date(order?.createdAt).setDate(new Date(order?.createdAt).getDate() + 3));
  }, [order]);

  const orderDateDelivery = useMemo(() => {
    return order?.createdAt && new Date(new Date(order?.createdAt).setDate(new Date(order?.createdAt).getDate() + 6));
  }, [order]);

  const isCommerceToolsOrder = useMemo(() => {
    return order?.orderSource == 'CommerceTools';
  }, [order]);

  const formattedOrderDate = useMemo(() => {
    if (!orderDateCreated) return;

    const dateArray = new Date(orderDateCreated).toDateString().split(' ');
    return orderDateCreated && `${dateArray[0]}, ${dateArray[1]} ${dateArray[2]}  ${dateArray[3]}`;
  }, [orderDateCreated]);

  const formattedShippingDate = useMemo(() => {
    if (!orderDateShipping) return;

    const dateArray = new Date(orderDateShipping).toDateString().split(' ');
    return orderDateShipping && `${dateArray[0]}, ${dateArray[1]} ${dateArray[2]}  ${dateArray[3]}`;
  }, [orderDateShipping]);

  const formattedDeliveryDate = useMemo(() => {
    if (!orderDateDelivery) {
      return;
    }
    const dateArray = new Date(orderDateDelivery).toDateString().split(' ');
    return orderDateDelivery && `${dateArray[0]}, ${dateArray[1]} ${dateArray[2]}  ${dateArray[3]}`;
  }, [orderDateDelivery]);

  const shippingName = useMemo(() => {
    return order?.shippingInfo?.shippingMethodId;
  }, [order, shippingMethods]);

  const shippingInfo = useMemo(() => {
    return `${orderDateDelivery && new Date(orderDateDelivery).toISOString().split('T')[0]} with ${shippingName}`;
  }, [orderDateDelivery, shippingName]);

  const orderDetailsShippingInfo = useMemo(() => {
    const shippingInfo =
      order?.custom?.deliveryOption === 'HomeDelivery' ? order?.shippingInfo?.description : 'Store Collection';
    return `${shippingInfo}`;
  }, [orderDateDelivery, shippingName]);

  const orderInfoLoaded = useMemo(() => {
    return order != null && order.orderNumber ? true : false;
  }, [order]);

  const paymentInfo = useMemo(() => {
    return order?.payments && `${order?.payments[0]?.paymentMethod}`;
    //return order?.payments && `${order?.payments[0]?.paymentMethod} **${order?.payments[0]?.cardSummary}`;
  }, [order?.payments]);

  const trackingURLs = useMemo(() => {
    const URLs: any[] = [];
    order?.shippingInfo?.deliveries?.forEach((delivery) =>
      delivery.parcels?.forEach((parcel) => URLs.push(parcel.trackingId)),
    );
    return URLs;
  }, [order?.shippingInfo]);

  return {
    shippingInfo,
    orderDetailsShippingInfo,
    paymentInfo,
    formattedOrderDate,
    formattedShippingDate,
    formattedDeliveryDate,
    trackingURLs,
    orderInfoLoaded,
    isCommerceToolsOrder,
  };
};
export default useOrderData;
